import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const DynamicPage = () => {
  const { state, grade, subject, view } = useParams();
  const [Component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        const component = await import(`../pages/${view === "Educator View" ? "educator" : "student"}/${state.toLowerCase()}-${view === "Educator View" ? "educator" : "student"}-${grade.toLowerCase()}-${subject}.js`);
        setComponent(() => component.default);
      } catch (error) {
        console.error("Error loading component:", error);
        setComponent(() => () => <h1>Page Not Found</h1>);
      }
    };

    loadComponent();
  }, [state, grade, subject, view]);

  return Component ? <Component /> : <p>Loading...</p>;
};

export default DynamicPage;
